<template>
  <div class="SpCallingCard" :style="style">
    <div v-for="(v,k) in contents" :key="'calling-'+k" class="calling-item">
      <div class="calling-key" :style="styleLeft">
        <div v-for="(key,index) in isJsonArray(k)?JSON.parse(k):[k]" :key="'calling-key-'+index" :style="popKeyStyle" class="calling-key-item">
          <template v-if="key.startsWith('$img$')">
            <img class="calling-item-img" :src="key.replace('$img$','')">
          </template>
          <template v-else>
            {{ key }}
          </template>
        </div>
      </div>
      <div class="calling-value" :style="styleRight">
        <div v-for="(value,index) in Array.isArray(v)?v:[v]" :key="'calling-key-'+index" :style="popValueStyle" class="calling-key-item">
          <template v-if="value.startsWith('$img$')">
            <img class="calling-item-img" :src="key.replace('$img$','')">
          </template>
          <template v-else>
            {{ value }}
          </template>
        </div>
      </div>
    </div>
    <span v-if="showEdit" class="edit-user-icon icon-edit iconfont sp-color-2" @click="toEdit" />
  </div>
</template>

<script type="text/ecmascript-6">
import WHcomputed from '@/mixins/WHcomputed'
import { isValid } from '@/utils'
export default {
  name: 'SpCallingCard',

  nameSpace: 'SpCallingCard',

  components: {
  },

  mixins: [WHcomputed],
  props: {
    content: {
      type: [Object, Array],
      default: () => {
        return null
      }
    },

    divide: {
      type: String,
      default: '1-1'
    },

    popKeyStyle: {
      type: Object,
      default: null
    },

    popValueStyle: {
      type: Object,
      default: null
    },

    showEdit: {
      type: Boolean,
      default: false
    },

    flexBasis: {
      type: String || Number,
      default: '50%'
    },

    flexLeft: {
      type: String || Number,
      default: '50%'
    }
  },

  data () {
    return {
    }
  },

  computed: {
    style () {
      const style = {}
      style.width = this.widthC
      style.height = this.heightC
      return style
    },

    contents () {
      if (!isValid(this.content)) {
        const user = this.$store.state.user.user
        if (Object.prototype.toString.call(user?.emails) === '[object Array]') {
          user.emails = user?.emails ? user?.emails?.join(',') : ''
        }
        return {
          [user.firstName]: `${user.affiliation.dept.name}(${user.affiliation.dept.city.name},${user.affiliation.dept.country.name})`,
          [user.lastName]: `Address:${user.affiliation.dept.address}`,
          [`${user.city.name},${user.country.name}`]: `Address:${user.affiliation.dept.subNode.defaultCorp.address}`,
          [`Mob:${user.mobileCode}-${user.mobileNo}`]: `Head/Group Name:${user.affiliation.dept.masterNode.defaultCorp.name}`,
          [`Skype:${user.skype}`]: [`${user.affiliation.dept.masterNode.defaultCorp.city.name},${user.affiliation.dept.masterNode.defaultCorp.country.name}`],
          [`Mail:${user.emails || ''}`]: '',
          [`$img$${user.avatar}`]: [`E-mail:${user.affiliation.dept.emails}`, `TEL(REP):${user.affiliation.dept.telRep}`, `TEL(DIR):${user.affiliation.dept.telDir}`],
          [`$img$${Object.values(user.affiliation.dept.photo || {})[0]}`]: [`Fax:${user.affiliation.dept.fax}`, `Skype:${user.affiliation.dept.skype}`, `Website:${user.affiliation.dept.subNode.defaultCorp.website}`]
        }
      }
      if (Array.isArray(this.content)) {
        const tmp = {}
        for (let i = 0; i < this.content.length; i += 2) {
          const key = this.content[i]
          tmp[Array.isArray(key) ? JSON.stringify(key) : key] = this.content[i + 1]
        }
        return tmp
      } else {
        return this.content
      }
    },

    styleLeft () {
      let style = { }
      if (this.flexLeft.includes('%') > 0) {
        style = { flexBasis: this.flexLeft }
        const divides = this.divide.split('-')
        if (divides.length > 1 && !isNaN(divides[0]) && !isNaN(divides[1])) {
          // style.flex = `1 1 ${divides[0] / (divides[0] / 1 + divides[1] / 1) * 100}%`
          style.flexBasis = `${divides[0] / (divides[0] / 1 + divides[1] / 1) * 100}%`
        }
      } else {
        style = {
          width: this.flexLeft + 'px'
        }
      }

      return style
    },

    styleRight () {
      let style = {}
      if (this.flexBasis.includes('%') > 0) {
        style = { flexBasis: this.flexBasis }
        const divides = this.divide.split('-')
        if (divides.length > 1 && !isNaN(divides[0]) && !isNaN(divides[1])) {
          // style.flex = `1 1 ${divides[1] / (divides[0] / 1 + divides[1] / 1) * 100}%`
          style.flexBasis = `${divides[1] / (divides[0] / 1 + divides[1] / 1) * 100}%`
        }
      } else {
        style = {
          flex: 1
        }
      }

      return style
    }
  },

  created () {
  },

  mounted () {
  },

  methods: {
    isJsonArray (json) {
      try {
        if (Array.isArray(JSON.parse(json))) {
          return true
        }
        return false
      } catch (e) {
        return false
      }
    },

    toEdit () {
      this.$router.push({ name: 'personalProfile', query: { back: true } })
    }
  }
}
</script>

<style scoped lang="less">
.SpCallingCard{
  font-size: 12px;
  font-family: Arial;
  font-weight: 400;
  color: #676767;
  position: relative;
  white-space: no-wrap;
  .edit-user-icon{
    position: absolute;
    font-size: 24px;
    right: 0;
    bottom: 10px;
    cursor: pointer;
  }
  .calling-item{
    // margin-top: 5px;
    -webkit-display:flex;
    -ms-display:flex;
    display:flex;
    -webkit-justify-content:center;
    -ms-justify-content:center;
    justify-content:center;
   .calling-key{
      text-align: right;
      box-sizing: border-box;
      padding-right: 20px;
    }
    .calling-value{
      text-align: left;
    }
    .calling-key-item, .calling-value-item{
      line-height: 20px;
    }
    .calling-item-img{
      vertical-align: middle;
      object-fit: contain ;
      max-width: 60px;
      // max-height:100%;
    }
  }
}
</style>
